import { useQuery } from "react-query";
import { getEmployeeTerminationStatus } from "../../../../../actions/Employees";

export const useEmployeeTerminationStatus = () => {
  return useQuery(
    "GetEmployeeTerminationStatus",
    getEmployeeTerminationStatus,
    {
      refetchOnWindowFocus: false,
    }
  );
};
